import http from '../../shared/http.js';
import { withFlash } from '../../shared/flash.js';
import { confirmAction, hideLoading, notifyError, showLoading } from '../../shared/notify.js';

// The administrator's reset on the user form. Everything at once - the passkeys
// and the recovery codes with them - because this is the backstop for somebody
// who has lost both, and leaving the codes would hand them a second factor they
// can no longer produce.
//
// Wired from the form's setup callback rather than as its own init*: the form is
// also delivered as a fragment into the shared modal, where a one-shot lookup at
// page load would find nothing. bindFormModule re-runs setup on every opening,
// so this is reached in the dialog and on the standalone page alike.
export function bindPasskeyReset(form) {
  const button = form.querySelector('#passkey-reset');
  if (!button) return;

  button.addEventListener('click', async () => {
    const confirmed = await confirmAction({
      title: 'Passkeys zurücksetzen',
      message:
        'Alle Passkeys und Wiederherstellungscodes dieses Benutzers werden entfernt. Die nächste Anmeldung erfolgt wieder nur mit Passwort. Fortfahren?',
      okText: 'Zurücksetzen'
    });
    if (!confirmed) return;

    showLoading('Passkeys werden zurückgesetzt …');

    try {
      await http.delete(`/users/${button.dataset.benutzer}/passkeys`);
      window.location.href = withFlash('/users', 'passkey-zurueckgesetzt');
    } catch (err) {
      hideLoading();
      notifyError(
        err.response?.data?.message || 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.'
      );
    }
  });
}
